// Oryn — Molekule-style product gallery: arrows overlaid on image + dot pagination
(function () {
  function setupGallery(gallery) {
    if (gallery.dataset.orynDotsInit) return;
    gallery.dataset.orynDotsInit = 'true';

    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    var dotsWrap = gallery.querySelector('.pdp-gallery-dots');
    if (!dotsWrap) return;

    slides.forEach(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pdp-gallery-dot';
      dot.setAttribute('aria-label', 'Image ' + (i + 1) + ' / ' + slides.length);
      dot.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.pdp-gallery-dot'));

    function getActiveIndex() {
      var listWidth = list.clientWidth || 1;
      return Math.round(list.scrollLeft / listWidth);
    }

    function setActiveDot(idx) {
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    var scrollSyncTimeout;
    function syncOnScroll() {
      clearTimeout(scrollSyncTimeout);
      scrollSyncTimeout = setTimeout(function () {
        setActiveDot(getActiveIndex());
      }, 80);
    }

    list.addEventListener('scroll', syncOnScroll, { passive: true });

    function initSync() {
      setActiveDot(getActiveIndex());
    }

    initSync();
    requestAnimationFrame(initSync);
    window.addEventListener('load', initSync, { once: true });
  }

  // Airback-style desktop layout: cap the vertical thumbnail column's height
  // to the main image's rendered height so it scrolls inside itself instead
  // of pushing the rest of the page down when there are many photos.
  function setupThumbHeight(gallery) {
    if (gallery.dataset.orynThumbHeightInit) return;
    if (gallery.getAttribute('data-desktop-layout') !== 'thumbnail') return;
    gallery.dataset.orynThumbHeightInit = 'true';

    var mainSlider = gallery.querySelector('.oryn-pdp-slider');
    var thumbSlider = gallery.querySelector('.thumbnail-slider');
    if (!mainSlider || !thumbSlider) return;

    var desktopMql = window.matchMedia('(min-width: 990px)');

    function sync() {
      if (desktopMql.matches) {
        var h = mainSlider.offsetHeight;
        if (h > 0) thumbSlider.style.maxHeight = h + 'px';
      } else {
        thumbSlider.style.maxHeight = '';
      }
    }

    sync();
    requestAnimationFrame(sync);
    window.addEventListener('load', sync, { once: true });
    window.addEventListener('resize', sync);

    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(mainSlider);
    }
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      setupGallery(gallery);
      setupThumbHeight(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
